import React, { Fragment } from 'react';

import Link from 'app/common/components/Link';
import { getAppUrl } from 'app/developer-v3/utils';
import { useAvroEvent, useRouter } from 'app/developer-v3/hooks';

type Props = {
  integrationId: number;
};

function ExploreEmbeddingTodo({ integrationId }: Props) {
  const { routeTo } = useRouter();
  const { emitPartnerUserInteractionEvent } = useAvroEvent();

  const integrationUrl = getAppUrl(integrationId);
  const embedUrl = `${integrationUrl}/embed`;

  function handleExploreEmbeddingClick(
    event: React.MouseEvent<HTMLButtonElement>
  ) {
    event.preventDefault();

    emitPartnerUserInteractionEvent({
      eventAction: 'click',
      interactionGoal: 'Navigate user to Embed Zapier page',
      interactionName: 'explore_embedding_link_clicked',
    });

    routeTo(embedUrl);
  }

  return (
    <Fragment>
      <Link href={embedUrl} onClick={handleExploreEmbeddingClick}>
        Explore embedding
      </Link>{' '}
      to bring thousands of integrations into your own product.
    </Fragment>
  );
}

export default ExploreEmbeddingTodo;
